module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.currForm,
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": !_vm.edit,
      "placeholder": "最多20个字"
    },
    model: {
      value: (_vm.currForm.name),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "name", $$v)
      },
      expression: "currForm.name"
    }
  }), _vm._v(" "), (_vm.currForm.id) ? _c('span', [_vm._v("当前装配人数：" + _vm._s(_vm.currForm.countUsed))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宣传图",
      "prop": "publicityPicture"
    }
  }, [_c('div', [_c('UploadImg', {
    attrs: {
      "imgUrl": _vm.currForm.homeRunSkinModel.publicityPicture,
      "disabled": _vm.edit
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "publicityPicture", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "publicityPicture", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("（尺寸：120*120，jpg、png）")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图",
      "prop": "displayPicture"
    }
  }, [_c('div', {
    staticClass: "bezel-list"
  }, [_c('div', {
    staticClass: "bezel-item"
  }, [_c('div', [_vm._v("跑步GO")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.currForm.homeRunSkinModel.runGo,
      "disabled": _vm.edit
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "runGo", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "runGo", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("（尺寸：130*130，jpg、png）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bezel-item"
  }, [_c('div', [_vm._v("滑动开启跑步")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.currForm.homeRunSkinModel.slideStart,
      "disabled": _vm.edit
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "slideStart", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "slideStart", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("（尺寸：100*100，jpg、png）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bezel-item"
  }, [_c('div', [_vm._v("跑步未达标")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.currForm.homeRunSkinModel.endScoreNoReach,
      "disabled": _vm.edit
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "endScoreNoReach", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "endScoreNoReach", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("（尺寸：120*120，jpg、png）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bezel-item"
  }, [_c('div', [_vm._v("跑步达标")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.currForm.homeRunSkinModel.endScoreReach,
      "disabled": _vm.edit
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "endScoreReach", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm.homeRunSkinModel, "endScoreReach", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("（尺寸：120*120，jpg、png）")])], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示排序",
      "prop": "sort"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": !_vm.edit
    },
    model: {
      value: (_vm.currForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "sort", $$v)
      },
      expression: "currForm.sort"
    }
  }), _vm._v(" "), _c('div', [_vm._v("数字越大越靠前")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拥有学生"
    }
  }, [_c('SelectStudent', {
    ref: "SelectStudentRef",
    attrs: {
      "disabled": _vm.edit,
      "selectVal": _vm.currForm.useType,
      "privileges": _vm.currForm.privilegeRole
    },
    on: {
      "update:selectVal": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      },
      "update:select-val": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角标图片"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.superscript),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "superscript", $$v)
      },
      expression: "currForm.superscript"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议40*40，最大50KB，优先SVG其次png")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-021bc8c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/RunningSkin.vue
// module id = 928
// module chunks = 0